import { render, staticRenderFns } from "./tabellaFaturato.html?vue&type=template&id=745f092a&scoped=true&"
import script from "./TabellaFatturato.vue?vue&type=script&lang=js&"
export * from "./TabellaFatturato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f092a",
  null
  
)

export default component.exports